import React from 'react';
import { HeartHandshake, ArrowUpRight } from 'lucide-react';
import { ABOUT_PAGE } from '../mock';
import Reveal from './Reveal';

const Education = () => {
  const { education } = ABOUT_PAGE;

  return (
    <section className="bg-cream">
      <div className="grid lg:grid-cols-2">
        {/* Text */}
        <div className="flex items-center px-6 py-14 md:px-14 md:py-20 xl:px-24">
          <div>
            <Reveal>
              <p className="mb-6 text-[10px] uppercase tracking-[0.45em] text-gold-dark">
                {education.label}
              </p>
            </Reveal>
            <Reveal delay={120}>
              <h2 className="font-serif text-4xl font-light leading-tight tracking-[0.03em] text-ink md:text-5xl">
                Education
                <br />
                Changes Everything
              </h2>
            </Reveal>
            <Reveal delay={220}>
              <div className="mt-6 h-px w-12 bg-gold" />
            </Reveal>
            <Reveal delay={300}>
              <div className="mt-8 max-w-md space-y-5">
                {education.paragraphs.map((p) => (
                  <p key={p} className="text-base leading-relaxed text-ink/70">
                    {p}
                  </p>
                ))}
              </div>
            </Reveal>
            <Reveal delay={400}>
              <a
                href={education.donateUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="education-donate-link"
                className="group mt-10 inline-flex items-center gap-3 bg-gold px-8 py-4 text-[11px] tracking-[0.25em] text-ink transition-colors duration-300 hover:bg-gold-dark hover:text-cream"
              >
                <HeartHandshake size={14} />
                DONATE TO THE CAUSE
                <ArrowUpRight
                  size={13}
                  className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                />
              </a>
            </Reveal>
          </div>
        </div>

        {/* Edge-to-edge photo with script overlay */}
        <div className="relative min-h-[55vh] overflow-hidden lg:min-h-0">
          <img
            src={education.image}
            alt="School children smiling in class"
            loading="lazy"
            className="absolute inset-0 h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-ink/35 via-transparent to-ink/10" />
          <div className="absolute right-6 top-6 text-right md:right-10 md:top-10">
            <p className="font-script text-4xl text-white drop-shadow-[0_2px_8px_rgba(0,0,0,0.6)] md:text-5xl">
              {education.scriptTop}
            </p>
            <p className="font-script text-4xl text-white drop-shadow-[0_2px_8px_rgba(0,0,0,0.6)] md:text-5xl">
              {education.scriptBottom}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Education;
